import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Search from '../../../components/searchField';
import Navigation from '../../../components/navigation';
import FeedbackSimple from './feedbackItem/simple';
import Pagination from '../../../components/pagination';
import './style.css';

const Feedback = ({
  t,
  count,
  filters,
  goToPage,
  criteria,
  feedback,
  statusList,
  showFilters,
  filtersCount,
  changeFilter,
  toggleFilters,
  backgroundCover,
  moduleTitle,
  enableCoverColor,
  backgroundColor,
  callbackToSetSearch }) => (
    <React.Fragment>
      <PageTitle
        title={moduleTitle}
        backgroundPage={backgroundColor}
        backgroundCover={backgroundCover}
        enableCoverColor={enableCoverColor}
      />
      <section className="Blog2 boxs simplepage2_D">
        <div className="container">
          <div className="Blog2inner boxs pdlr">
            <Navigation />
            <div className="middleKB">
              <div className="middleinner boxs">
                <Search callbackToSetSearch={callbackToSetSearch} placeholder={t('Search')} />
                <div className="spleftwfull boxs">
                  <div className="boxs fedbacD">
                    <div className={`featurereq ${backgroundColor}`}>
                      <Link
                        to="/feedback/add-new"
                        className="tc thm-text"
                      >{t('Add new feature request')}
                      </Link>
                    </div>
                    <div className="featurereqfilter">
                      <div className="filter boxs">
                        <h3 onClick={e => toggleFilters(e)} className="pointer">{t('Filters')}
                          <span className="current">{filtersCount}</span>
                          <img
                            src="/img/droparrow.svg"
                            height="6px"
                            alt="droparrow"
                            id="showMore"
                            className={`img-more  ${showFilters ? 'rotate_act' : 'rotate_dis'}`}
                          />
                        </h3>
                      </div>
                      {showFilters &&
                      <div className={`status-box ${backgroundColor}`}>
                        <p className="tc thm-text">{`${t('Status')}:`}</p>
                        {Object.entries(statusList(t)).map(([k, v]) =>
                          (<a
                            key={k}
                            href="#"
                            className={filters[k] ? 'tc tc_act' : 'tc tc_dis st-dis'}
                            onClick={e => changeFilter(e, k)}
                          >{v}
                           </a>))}
                      </div>}
                    </div>
                  </div>
                  <div className="boxs">
                    <div className="BlogsBoxouter boxs">
                      {feedback.length ? feedback.map(el =>
                        (
                          <Link to={`/feedback/${el.id}`} key={el.id} className="link-smplBox" >
                            <FeedbackSimple item={el} simple />
                          </Link>
                        )) :
                      <div className="BlogsBox boxs BlogsBoxkb smpleBox2">
                        <div className="right feedback-align-center-text">
                          <h5>{t('Nothing to show')}</h5>
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  <Pagination
                    goToPage={goToPage}
                    count={count}
                    pageSize={criteria.limit}
                    page={criteria.page}
                    backgroundColor={backgroundColor}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
);

Feedback.propTypes = {
  t: PropTypes.func.isRequired,
  callbackToSetSearch: PropTypes.func.isRequired,
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/views/modules/feedback/Feedback.jsx